module.exports = __webpack_public_path__ + "img/e5.0aa8a14a.jpg";